export default __webpack_public_path__ + "static/media/Fence's Gloves of Whispered Deeds.1b5b040c.jpg";